// extracted by mini-css-extract-plugin
export default {"container":"skills_container__I1qGZ","container__wrapper":"skills_container__wrapper__3I-X-"};